// ADDRESS TYPES

export const RESIDENTIAL = "RESIDENTIAL";
export const MAILING = "MAILING";
